const links = {
  instantPayouts:"https://www.i-payout.com/blog/why-gig-workers-in-the-us-demand-instant-payouts",
  securedCreditDocs:"https://docs.galileo-ft.com/pro/docs/secured-credit",
  accountLevelAuthControls:"https://docs.galileo-ft.com/pro/docs/account-level-auth-controls",
  aboutInstantVerificationEngine:"https://docs.galileo-ft.com/pro/docs/about-galileo-instant-verification-engine",
  aboutPRP:"https://docs.galileo-ft.com/pro/docs/about-payment-risk-platform#managed-vs-self-service-prp",
  setupDigitalFirst:"https://docs.galileo-ft.com/pro/docs/setup-for-digital-first",
 corporateCreditDocs:"https://docs.galileo-ft.com/pro/docs/corporate-credit",
  paymentHubAPI:"https://docs.galileo-ft.com/pro/reference/api-reference-about-the-payment-hub-api",
  secureAccessControlServer:"https://docs.galileo-ft.com/pro/docs/3-d-secure-access-control-server",
  creatingProvisioningRequest:"https://docs.galileo-ft.com/pro/docs/creating-a-provisioning-request",
  applicantPrivacyPolicy:
    "https://www.sofi.com/sofi-employee-applicant-privacy-notice/",
  aboutTheAPIGuides:
    "https://docs.galileo-ft.com/pro/docs/about-the-api-guides/",
  marketShareEbook:
    "https://www.galileo-ft.com/lp/grow-your-market-share-ebook/",
  login: "https://console.galileo-ft.com/",
  advertisementOptOut: "http://optout.networkadvertising.org/?c=1",
  flashPlayer:
    "http://helpx.adobe.com/flash-player/kb/disable-local-shared-objects-flash.html",
  privacyEmail: "privacy@galileo-ft.com",
  infoEmail: "info@galileo-ft.com.",
  privacyColumbiaEmail: "privacy_colombia@galileo-ft.com",
  accessibilityEmail: "accessibilityteam@sofi.org",
  accessibilityPhone: "(855) 456-7634",
  accessibilityPhoneLink: "+18554567634",
  securedCreditReport: "https://www.galileo-ft.com/lp/secured-credit-report/",
  twitter: "https://twitter.com/galileofintech?lang=en",
  youtube: "https://www.youtube.com/c/GalileoFinancialTechnologies",
  linkedin: "https://www.linkedin.com/company/galileo-financial-technologies/",
  helpClientsVideo: "https://youtu.be/CvXLrxQldZI",
  dave: "https://dave.com",
  embeddedFinanceReport:
    "https://www.galileo-ft.com/lp/embedded-finance-report/",
  apiSandbox: "https://sandbox.gpsrv.com/auth/login",
  programApi: "https://docs.galileo-ft.com/pro/reference/program-api-intro",
  eventsApi:
    "https://docs.galileo-ft.com/pro/reference/api-reference-events-api-about-events-api",
  authApi:
    "https://docs.galileo-ft.com/pro/reference/api-reference-auth-api-about-auth-api",
  disputesApi:
    "https://docs.galileo-ft.com/pro/reference/api-reference-about-the-dispute-api",
  externalTransApi:
    "https://docs.galileo-ft.com/pro/reference/api-reference-external-trans-api-about-external-trans-api",
  guides: "https://docs.galileo-ft.com/pro/docs",
  recipes: "https://docs.galileo-ft.com/pro/recipes",
  verifyAccount: "https://docs.galileo-ft.com/pro/reference/post_verifyaccount",
  achEarlyAccess:
    "https://docs.galileo-ft.com/pro/docs/ach-at-galileo#ach-early-access",
  postSetroundUpaaccounts:
    "https://docs.galileo-ft.com/pro/reference/post_setroundupaccounts",
  getOverdraftBalance:
    "https://docs.galileo-ft.com/pro/reference/post_getoverdraftbalance",
  robinhood: "https://robinhood.com",
  moneyLion: "https://moneylion.com",
  tala: "https://tala.co",
  aspiration: "https://aspiration.com",
  flyp: "https://joinflyp.com",
  pomelo: "https://pomelo.com",
  changeLog: "https://docs.galileo-ft.com/pro/changelog",
  createADispute: "https://docs.galileo-ft.com/pro/docs/creating-a-dispute",
  authControl: "https://docs.galileo-ft.com/pro/reference/post_getauthcontrol",
  hAndR: "https://www.hrblock.com/",
  nextGenDigitalBankingAtMassiveScale:
    "https://galileo-ft.com/lp/next-gen-digital-banking-at-massive-scale/",
  consumerBankingReport:
    "https://www.galileo-ft.com/lp/the-galileo-consumer-banking-report-by-datos-insights/",
  bankingModernizationBusinessCase:
    "https://www.galileo-ft.com/lp/making-the-banking-modernization-business-case/",
  fraudManagement:
    "https://www.galileo-ft.com/blog/balancing-fraud-prevention-customer-experience/",
  BNPLPostPurchase:
    "https://www.galileo-ft.com/news/galileo-launches-bnpl-post-purchase-for-credit-and-debit/",
  BNPLPrePurchase:
    "https://www.galileo-ft.com/blog/where-does-buy-now-pay-later-fit-in-the-future-of-banking/",
  securedCard:
    "https://www.galileo-ft.com/news/galileo-launches-secured-credit-with-dynamic-funding/",
}

export default links
